import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Intro,
  Showcase,
  Header,
  SectionTitle,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        complete={true}
        slug={data.slug + '/develop/'}
        site={data.site}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            A checkbox is a type of input that can be used in one of two ways.
            As a standalone option it allows the user to visually record a
            yes/no response. In a form list, it allows the user to select
            multiple options for a single prompt. To restrict the user to
            selecting only one option, use the{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/radio/develop'}
            >
              radio
            </Link>{' '}
            component.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          title="Standalone"
          text={
            <p>
              Use this component as a standalone when it will function as a
              yes/no response. Other components can be nested to appear within
              the container in the checked state. There should be a{' '}
              <span class="inline__code">l-margin-top--medium</span> on the
              input to create 16px of space between the container and the
              previous component.
            </p>
          }
          code={code.checkbox}
        >
          <div class="c-checkbox__container">
            <div>
              <input class="c-checkbox__input" type="checkbox" id="checkbox3" />
              <label class="c-checkbox" htmlFor="checkbox3">
                I Agree
                <span class="c-checkbox__checkmark">
                  <svg
                    class="c-checkbox__checkmark-icon"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="#fff"
                  >
                    <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"></path>
                  </svg>
                </span>
              </label>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="List"
          code={code.checkboxList}
          text="Use this component in a list when the user can choose more than one of multiple options. Options should be listed vertically with one checkbox per row."
        >
          <div class="c-checkbox-group">
            <div class="c-checkbox__container">
              <input class="c-checkbox__input" type="checkbox" id="checkbox5" />
              <label class="c-checkbox" htmlFor="checkbox5">
                Option 1
                <span class="c-checkbox__checkmark">
                  <svg
                    class="c-checkbox__checkmark-icon"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="#fff"
                  >
                    <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
                  </svg>
                </span>
              </label>
            </div>
            <div class="c-checkbox__container">
              <input class="c-checkbox__input" type="checkbox" id="checkbox6" />
              <label class="c-checkbox" htmlFor="checkbox6">
                Option 2
                <span class="c-checkbox__checkmark">
                  <svg
                    class="c-checkbox__checkmark-icon"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="#fff"
                  >
                    <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
                  </svg>
                </span>
              </label>
            </div>
            <div class="c-checkbox__container">
              <input class="c-checkbox__input" type="checkbox" id="checkbox7" />
              <label class="c-checkbox" htmlFor="checkbox7">
                Option 3
                <span class="c-checkbox__checkmark">
                  <svg
                    class="c-checkbox__checkmark-icon"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="#fff"
                  >
                    <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
                  </svg>
                </span>
              </label>
            </div>
          </div>
        </Showcase>
        <hr />

        <SectionTitle>States</SectionTitle>
        <Showcase
          code={code.listError}
          text={
            <p>
              In addition to the default state, every checkbox option has a
              hover state, a focus state, a checked state and an error state. In
              a list, the error state affects the entire list container. Use the{' '}
              <span className="inline__code">c-checkbox__container--error</span>{' '}
              class to apply the error state to a standalone checkbox and{' '}
              <span className="inline__code">c-checbox-group--error</span> class
              to apply the error to a checkbox group. The error state must be
              used with an{' '}
              <Link
                to={'/' + data.site + '/components/inline-error/design/'}
                className="link"
              >
                input error
              </Link>{' '}
              component to guide the user in correcting the error.
            </p>
          }
        >
          <div class="c-checkbox__container c-checkbox__container--error">
            <input class="c-checkbox__input" type="checkbox" id="checkbox5" />
            <label class="c-checkbox" htmlFor="checkbox5">
              I Agree
              <span class="c-checkbox__checkmark">
                <svg
                  class="c-checkbox__checkmark-icon"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32 32"
                  fill="#fff"
                >
                  <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
                </svg>
              </span>
            </label>
          </div>
          <span class="c-inline-error">
            <i class="icon icon--error c-inline-error__icon"></i>
            <span class="c-inline-error__content">
              You must agree to our Terms of Use.
            </span>
          </span>
          <br />
          <div class="c-checkbox-group c-checkbox-group--error">
            <div class="c-checkbox__container">
              <input class="c-checkbox__input" type="checkbox" id="checkbox5" />
              <label class="c-checkbox" htmlFor="checkbox5">
                Option 1
                <span class="c-checkbox__checkmark">
                  <svg
                    class="c-checkbox__checkmark-icon"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="#fff"
                  >
                    <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
                  </svg>
                </span>
              </label>
            </div>
            <div class="c-checkbox__container">
              <input class="c-checkbox__input" type="checkbox" id="checkbox6" />
              <label class="c-checkbox" htmlFor="checkbox6">
                Option 2
                <span class="c-checkbox__checkmark">
                  <svg
                    class="c-checkbox__checkmark-icon"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="#fff"
                  >
                    <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
                  </svg>
                </span>
              </label>
            </div>
            <div class="c-checkbox__container">
              <input class="c-checkbox__input" type="checkbox" id="checkbox7" />
              <label class="c-checkbox" htmlFor="checkbox7">
                Option 3
                <span class="c-checkbox__checkmark">
                  <svg
                    class="c-checkbox__checkmark-icon"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="#fff"
                  >
                    <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
                  </svg>
                </span>
              </label>
            </div>
          </div>
          <span class="c-inline-error">
            <i class="icon icon--error c-inline-error__icon"></i>
            <span class="c-inline-error__content">
              You must choose at least two options.
            </span>
          </span>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  checkbox: `<div class="c-checkbox__container">
  <div>
    <input class="c-checkbox__input" type="checkbox" id="checkbox3" />
    <label class="c-checkbox" for="checkbox3">
      I Agree
      <span class="c-checkbox__checkmark">
        <svg
          class="c-checkbox__checkmark-icon"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="#fff"
        >
          <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"></path>
        </svg>
      </span>
    </label>
  </div>
</div>
`,
  checkboxDefault: `<div class="c-checkbox__container">
    <label class="c-checkbox"> Default Checkbox
        <input class="c-checkbox__input" type="checkbox" />
        <span class="c-checkbox__checkmark">
            <svg class="c-checkbox__checkmark-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="#fff">
                <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"></path>
            </svg>
        </span>
    </label>
</div>
`,
  checkboxStandalone: `<div class="c-checkbox__container">
    <div>
        <label class="c-checkbox"> No
            <input class="c-checkbox__input" type="checkbox" />
            <span class="c-checkbox__checkmark">
                <svg class="c-checkbox__checkmark-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="#fff">
                    <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"></path>
                </svg>
            </span>
        </label>
    </div>
</div>
<br/>
<div class="c-checkbox__container">
    <div>
        <label class="c-checkbox"> Yes
            <input class="c-checkbox__input" type="checkbox" />
            <span class="c-checkbox__checkmark">
                <svg class="c-checkbox__checkmark-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="#fff">
                    <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"></path>
                </svg>
            </span>
        </label>
    </div>
</div>
`,
  checkboxList: `
  <div class="c-checkbox-group">
  <div class="c-checkbox__container">
    <input class="c-checkbox__input" type="checkbox" id="checkbox5" />
    <label class="c-checkbox" for="checkbox5">
      No
      <span class="c-checkbox__checkmark">
        <svg
          class="c-checkbox__checkmark-icon"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="#fff"
        >
          <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
        </svg>
      </span>
    </label>
  </div>
  <div class="c-checkbox__container">
    <input class="c-checkbox__input" type="checkbox" id="checkbox6" />
    <label class="c-checkbox" for="checkbox6">
      Yes
      <span class="c-checkbox__checkmark">
        <svg
          class="c-checkbox__checkmark-icon"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="#fff"
        >
          <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
        </svg>
      </span>
    </label>
  </div>
  <div class="c-checkbox__container">
    <input class="c-checkbox__input" type="checkbox" id="checkbox7" />
    <label class="c-checkbox" for="checkbox7">
      Maybe
      <span class="c-checkbox__checkmark">
        <svg
          class="c-checkbox__checkmark-icon"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="#fff"
        >
          <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
        </svg>
      </span>
    </label>
  </div>
</div>
`,
  listError: `<div class="c-checkbox-group c-checkbox-group--error">
<div class="c-checkbox__container">
  <input class="c-checkbox__input" type="checkbox" id="checkbox5" />
  <label class="c-checkbox" for="checkbox5">
    Option 1
    <span class="c-checkbox__checkmark">
      <svg
        class="c-checkbox__checkmark-icon"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="#fff"
      >
        <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
      </svg>
    </span>
  </label>
</div>
<div class="c-checkbox__container">
  <input class="c-checkbox__input" type="checkbox" id="checkbox6" />
  <label class="c-checkbox" for="checkbox6">
    Option 2
    <span class="c-checkbox__checkmark">
      <svg
        class="c-checkbox__checkmark-icon"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="#fff"
      >
        <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
      </svg>
    </span>
  </label>
</div>
<div class="c-checkbox__container">
  <input class="c-checkbox__input" type="checkbox" id="checkbox7" />
  <label class="c-checkbox" for="checkbox7">
    Option 3
    <span class="c-checkbox__checkmark">
      <svg
        class="c-checkbox__checkmark-icon"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="#fff"
      >
        <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
      </svg>
    </span>
  </label>
</div>
</div>
<span class="c-inline-error">
<i class="icon icon--error c-inline-error__icon"></i>
<span class="c-inline-error__content">
  You must choose at least two options.
</span>
</span>`,
}
